<div class="content">
    <div class="container-fluid">
        <div class="card shadow p-3">
            <div class="card-body form-container">
                ria
            </div>
        </div>
    </div>
</div>